import React from 'react';

export const Spinner = ({ size, className, children }) => {
  return (
    <>
      <div className={`custom-spinner ${className || ''} ${size || ''}`} />
      <div className='t-block t-font-normal'>{children}</div>
    </>
  );
};

export const ModalSpinner = (props) => {
  return (
    <div className='custom-spinner-wrapper'>
      <Spinner size='lg' {...props} />
    </div>
  );
};
